import React from 'react';
import Sidebar from '../components/Sidebar';
import { Outlet, useLocation } from 'react-router-dom';
import { useLayout } from '../contexts/LayoutContext';
import '../styles/MainLayout.css';

const MainLayout = () => {
  const { pathname } = useLocation();
  const { mobileSidebarOpen, closeMobileSidebar, setSidebarMounted } = useLayout();
  const [collapsed, setCollapsed] = React.useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  // Sinaliza ao Navbar que existe uma sidebar nesta rota (controla o hambúrguer).
  React.useEffect(() => {
    setSidebarMounted(true);
    return () => setSidebarMounted(false);
  }, [setSidebarMounted]);

  const handleToggle = () => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebar-collapsed', String(next));
      return next;
    });
    // O sidebar anima a largura por 0.5s (MainLayout.css / Sidebar.css). Componentes que
    // calculam a largura no render (ex.: FullCalendar) não percebem essa mudança porque
    // não há resize de janela — ficando com espaço em branco. Disparamos 'resize' ao longo
    // da transição para que recalculem e ocupem toda a largura disponível.
    [120, 280, 440, 560].forEach((delay) => {
      window.setTimeout(() => window.dispatchEvent(new Event('resize')), delay);
    });
  };

  return (
    <div className={`layout-container${collapsed ? ' sidebar-collapsed' : ''}${mobileSidebarOpen ? ' mobile-sidebar-open' : ''}`}>
      <Sidebar collapsed={collapsed} onToggle={handleToggle} />
      {mobileSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeMobileSidebar} aria-hidden="true" />
      )}
      <div className="layout-main-content">
        <div id="conteudo-pagina" tabIndex={-1} className={`page-body${pathname.startsWith('/tarefas') ? ' page-body-tarefas' : ''}${pathname.startsWith('/assistente') ? ' page-body-assistente' : ''}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
